//礼品卡
export const ZUKER_GET_GIFTCARD_LIST = {
    name: '根据手机号获取卡号列表',
    api: '${ZUKER}/ma-tenant/api/D/cardInstance/list',
    method: 'post',
    doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#/商户通应用API/礼品卡核销/反核销/记录/listUsingPOST',
  };


export const ZUKER_GET_GIFTCARD_INFO = {
    name: '根据手机号获取卡号列表',
    api: '${ZUKER}/ma-tenant/api/D/cardInstance/info',
    doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#/商户通应用API/礼品卡核销/反核销/记录/listUsingPOST',
  };

export const ZUKER_GET_MSGCODE = {
    name: '获取验证码',
    api: '${ZUKER}/ma-tenant/api/D/sms/sendCode',
    doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#/商户通应用API/礼品卡核销/反核销/记录/listUsingPOST',
  };

export const ZUKER_WRITEOFF_GIFTCARD = {
    name: '礼品卡核销接口',
    api: '${ZUKER}/ma-tenant/api/card/instanceWriteOff/writeOff',
    method: 'post',
    doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#/商户通应用API/礼品卡核销/反核销/记录/listUsingPOST',
  };


  export const ZUKER_WRITEOFF_LIST = {
    name: '礼品卡核销记录接口',
    api: '${ZUKER}/ma-tenant/api/D/cardInstanceFlow/list',
    method: 'post',
    doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#/商户通应用API/礼品卡核销/反核销/记录/listUsingPOST',
  };


  export const ZUKER_WRITEOFF_CONFIRM = {
    name: '礼品卡核销',
    api: '${ZUKER}/ma-tenant/api/D/instanceWriteOff/returnWriteOff',
    method: 'post',
    doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#/商户通应用API/礼品卡核销/反核销/记录/listUsingPOST',
  };

  export const ZUKER_WRITEOFF_DETAIL = {
    name: '礼品卡核销',
    api: '${ZUKER}/ma-tenant/api/D/cardInstanceFlow/flowInfo',
    doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#/商户通应用API/礼品卡核销/反核销/记录/listUsingPOST',
  };


  export const ZUKER_WRITEOFF_NOTREFUNDLIST = {
    name: '礼品卡核销记录接口',
    api: '${ZUKER}/ma-tenant/api/D/cardInstanceFlow/notRefundList',
    method: 'post',
    doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#/商户通应用API/礼品卡核销/反核销/记录/listUsingPOST',
  };


  

